// BackButton — the one standard way back (TRIAGE_V2 builds). Small text link at top-left,
// chevron + "Back"; the invisible padding keeps a >=44pt tap target. `floating` pins it inside a
// positioned overlay below the notch.
import React from 'react';
import { Icon } from '@/components/icons';
import { C, F, SIZE, W } from '@/new/theme';

export function BackButton({ onClick, floating = false, style }: { onClick: () => void; floating?: boolean; style?: React.CSSProperties }) {
  return (
    <button
      type="button"
      onClick={onClick}
      aria-label="Back"
      style={{
        display: 'inline-flex', alignItems: 'center', gap: 2, minHeight: 44, padding: '0 10px', marginLeft: -10,
        border: 'none', background: 'none', color: C.brandDark, cursor: 'pointer', flexShrink: 0,
        fontFamily: F.ui, fontSize: SIZE.body, fontWeight: W.semibold, WebkitTapHighlightColor: 'transparent',
        ...(floating ? { position: 'absolute', top: 'calc(var(--safe-top) + 8px)', left: 22, zIndex: 3 } : null),
        ...style,
      }}
    >
      <Icon name="chevLeft" size={14} />
      <span>Back</span>
    </button>
  );
}
